import { Typography } from "@mui/material";
import AppStateContext from "contexts/AppStateContext";
import { useContext, useEffect, useState } from "react";
import { apiGetManufacturedProductCalculationValues } from "../../../util/network/Products";
import styles from "components/Modals/ModalStyles/threeDModalStyle.module.css";
import {
  ManufacturedProductDetailsType,
  ProductTypeEnum,
  ProductVMType,
} from "types/products/ProductCommandsType";

const PriceTab: React.FC<{
  product: ProductVMType;
}> = ({ product }) => {
  const details = product.details as ManufacturedProductDetailsType;
  // CNC Details
  const renderCNCDetails = () => {
    if (details.priceCalculation == undefined) {
      return "No pricing data";
    }

    return (
      <div className={styles.textRow}>
        {/*  Column 1 */}
        <div className={styles.textColumn}>
          {/* Material Info */}
          <div className={styles.textTable}>
            <span className={styles.sectionHeader}>Material Analysis</span>
            {/* <span className={classes.sectionHeader}>{pricedetails.material.price.toFixed(0)} kr</span> */}
          </div>
          <div className={styles.textTable}>
            <span>Length</span>
            <span>{details.priceCalculation.material.x.toFixed(0)} mm</span>
          </div>
          <div className={styles.textTable}>
            <span>Width</span>
            <span>{details.priceCalculation.material.y.toFixed(0)} mm</span>
          </div>
          <div className={styles.textTable}>
            <span>Thickness</span>
            <span>{details.priceCalculation.material.z.toFixed(0)} mm</span>
          </div>
          <div className={styles.textTable}>
            <span>Weight PP</span>
            <span>
              {details.priceCalculation.material.singleStockWeight.toFixed(1)}{" "}
              kg
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Weight Total</span>
            <span>
              {details.priceCalculation.material.totalStockWeight.toFixed(1)} kg
            </span>
          </div>

          <div className={styles.textTable}>
            <span>Clamping</span>
            <span>{details.priceCalculation.material.clamping}</span>
          </div>

          {/* CAM Details */}
          <div className={styles.textTable}>
            <span className={styles.sectionHeader}>CAM Analysis</span>
          </div>
          <div className={styles.textTable}>
            <span>Time</span>
            <span>
              {details.priceCalculation.machining.camDetails.time.toFixed(0)}{" "}
              min
            </span>
          </div>

          {/* Machining Details */}
          <div className={styles.textTable}>
            <span className={styles.sectionHeader}>Machining Analysis</span>
          </div>
          <div className={styles.textTable}>
            <span>Technology</span>
            <span>{details.priceCalculation.machining.technology}</span>
          </div>
          <div className={styles.textTable}>
            <span>Setups</span>
            <span>
              {details.priceCalculation.machining.machiningDetails.setups}
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Setup Time</span>
            <span>
              {details.priceCalculation.machining.machiningDetails.setupTime}{" "}
              min
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Machining Time</span>
            <span>
              {details.priceCalculation.machining.machiningDetails.machiningTime.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>

          {/* Machining Details */}
          <div className={styles.textTable}>
            <span className={styles.sectionHeader}>
              Surface Treatment Analysis
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Price</span>
            <span>{details.priceCalculation.finish.price.toFixed(0)} kr</span>
          </div>
          <div className={styles.textTable}>
            <span>Leadtime</span>
            <span>{details.priceCalculation.finish.leadtime} days</span>
          </div>
        </div>

        {/* Column 2 */}
        <div className={styles.textColumn}>
          {/* Cost Details */}
          <div className={styles.textTable}>
            <span className={styles.sectionHeader}>Cost Analysis</span>
          </div>

          {/* Time */}
          <div className={styles.textTable}>
            <span>Prep. Time</span>
            <span>
              {details.priceCalculation.machining.costDetails.machinePrepTime.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Validation Time</span>
            <span>
              {details.priceCalculation.machining.costDetails.validationTime.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Setup Time (pp)</span>
            <span>
              {details.priceCalculation.machining.costDetails.setupTimePP.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Machining Time (pp)</span>
            <span>
              {details.priceCalculation.machining.costDetails.machiningTimePP.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Operation Time (pp)</span>
            <span>
              {details.priceCalculation.machining.costDetails.operationTimePP.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Manual Time (pp)</span>
            <span>
              {details.priceCalculation.machining.costDetails.manualFinishTimePP.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>

          <hr />

          <div className={styles.textTable}>
            <span>Machine Time</span>
            <span>
              {details.priceCalculation.machining.costDetails.machineTime.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Operator Time</span>
            <span>
              {details.priceCalculation.machining.costDetails.operatorTime.toFixed(
                0,
              )}{" "}
              min
            </span>
          </div>

          <hr />

          {/* Cost */}
          <div className={styles.textTable}>
            <span>Operator Cost</span>
            <span>
              {details.priceCalculation.machining.costDetails.operatorCost.toFixed(
                0,
              )}{" "}
              kr
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Machine Cost</span>
            <span>
              {details.priceCalculation.machining.costDetails.machineCost.toFixed(
                0,
              )}{" "}
              kr
            </span>
          </div>
          <div className={styles.textTable}>
            <span>Tool Cost</span>
            <span>
              {details.priceCalculation.machining.costDetails.toolCost.toFixed(
                0,
              )}{" "}
              kr
            </span>
          </div>
          <div className={styles.textTable}>
            <span className={styles.boldParagraph}>Total Cost</span>
            <span className={styles.boldParagraph}>
              {details.priceCalculation.machining.costDetails.totalCost.toFixed(
                0,
              )}{" "}
              kr
            </span>
          </div>

          {/* Price Details */}
          <div className={styles.textTable}>
            <span className={styles.sectionHeader}>Price Analysis</span>
            {/* <span className={styles.sectionHeader}>{pricedetails.machining.cost.toFixed(0)} kr</span> */}
          </div>
          <div className={styles.textTable}>
            <span>Economic</span>
            <span>{product?.priceEconomic.toFixed(0)} kr</span>
          </div>
          <div className={styles.textTable}>
            <span>Standard</span>
            <span>{product.priceStandard.toFixed(0)} kr</span>
          </div>
          <div className={styles.textTable}>
            <span>Express</span>
            <span>{product.priceExpress.toFixed(0)} kr</span>
          </div>
        </div>
      </div>
    );
  };

  const renderProductDetails = () => {
    if (product == undefined) {
      return <div>{"Missing product"}</div>;
    }

    switch (product?.productType) {
      case ProductTypeEnum.CNC:
        return renderCNCDetails();
      case ProductTypeEnum.SHEET:
        return <div>{/* Your Sheet-specific content here */}</div>;
      case ProductTypeEnum.PRINT3D:
        return <div>{/* Your 3D Print-specific content here */}</div>;
      default:
        return (
          <Typography className={styles.typography_config}>
            {"No pricing data"}
          </Typography>
        );
    }
  };

  return <div>{renderProductDetails()}</div>;
};

export default PriceTab;
